export const environment = {
  production: true,
  locale: ['en', 'sl']
};



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/environments/environment.ts